import gql from 'graphql-tag';
import { PARCEL_PROFILE_FRAGMENT } from './fragments.graphql';

export const GET_PARCEL_PROFILES = gql`
    query GetParcelProfiles($options: ParcelProfileListOptions) {
        parcelProfiles(options: $options) {
            items {
                ...ParcelProfile
            }
            totalItems
        }
    }
    ${PARCEL_PROFILE_FRAGMENT}
`;

export const GetParcelProfileListDocument = gql`
  query GetParcelProfileList($options: ParcelProfileListOptions) {
    parcelProfiles(options: $options) {
      items {
        ...ParcelProfile
      }
      totalItems
    }
  }
  ${PARCEL_PROFILE_FRAGMENT}
`;

export const ASSIGN_PARCEL_PROFILE_TO_CHANNELS = gql`
  mutation AssignParcelProfile($id: ID!, $channelIds: [ID!]!) {
    assignParcelProfileToChannels(id: $id, channelIds: $channelIds) {
      id
      channels {
        id
        code
      }
    }
  }
`;

export const REMOVE_PARCEL_PROFILE_FROM_CHANNELS = gql`
  mutation RemoveParcelProfile($id: ID!, $channelIds: [ID!]!) {
    removeParcelProfileFromChannels(id: $id, channelIds: $channelIds) {
      id
      channels {
        id
        code
      }
    }
  }
`;

export const DELETE_PARCEL_PROFILE = gql`
  mutation DeleteParcelProfile($id: ID!) {
    deleteParcelProfile(id: $id) {
      ... on ParcelProfileDeletionResponse {
        success
      }
    }
  }
`;

export const CREATE_PARCEL_PROFILE = gql`
    mutation CreateParcelProfile($input: CreateParcelProfileInput!) {
        createParcelProfile(input: $input) {
            ...ParcelProfile
        }
    }
    ${PARCEL_PROFILE_FRAGMENT}
`;

export const GET_PARCEL_PROFILE = gql`
  query GetParcelProfile($id: ID!) {
    parcelProfile(id: $id) {
      ...ParcelProfile
    }
  }
  ${PARCEL_PROFILE_FRAGMENT}
`;

export const UPDATE_PARCEL_PROFILE = gql`
    mutation UpdateParcelProfile($input: UpdateParcelProfileInput!) {
        updateParcelProfile(input: $input) {
            ...ParcelProfile
        }
    }
    ${PARCEL_PROFILE_FRAGMENT}
`;

